export default function Pandas_Intro() {
  return <div>Pandas_Intro </div>;
}
